import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z"
}), 'SwapHorizontalCircle');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwapHorizontalCircle.js
// module id = 6608
// module chunks = 2